const urlPattern = new RegExp(
    '^(https?:\\/\\/)?' + 
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + 
    '((\\d{1,3}\\.){3}\\d{1,3}))' + 
    '(\\:\\d+)?' + 
    '(\\/[-a-z\\d%_.~+]*)*' + 
    '(\\?[;&a-z\\d%_.~+=-]*)?' +
    '(\\#[-a-z\\d_]*)?$','i'
);

export const obtenerEstado = async (codigoMonitoreo, todos = false) => {
  try {
    if(codigoMonitoreo === undefined || codigoMonitoreo === null || codigoMonitoreo === ""){
      return {Estado:'Sin monitorear',urls:[], messageError: []}
    }
    const requests = extractRequestsFromJson(codigoMonitoreo, todos);
    if(requests.length !== 0){
      const responses = await Promise.all(requests.map(async ({ method, url, headers, body }) => {
        try {
          if(headers){
            let headersB = {
              // "User-Agent": "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/134.0.0.0 Safari/537.36",
              // "Connection": "keep-alive",
              // "Accept": "*/*",
            }
            headers = { ...headers, ...headersB}
          }
          let peticion = {
            method,
            headers,
          }
          
          const cuerpo = prepararCuerpo(body);
          if (cuerpo) {
            peticion.body = cuerpo;
          }

          if (urlPattern.test(url)) {
            const response = await fetch(url, peticion);
            if (response.status >= 400 && response.status < 600) {
              try{
                let data = await response.json();
                return { url, status: response.status, error: data.mensaje.message || data.mensaje || data.message || response.statusText}
              }
              catch{
                return { url, status: response.status, error: response.status}
              }
            }
            return { url, status: response.status };
          }
          return { url, status: 500, error: "URL no válido." };
        } catch (error) {
          const regexQuery = "^(https?:\\/\\/)?((([-a-z0-9]{1,63}\\.)*?[a-z0-9]([-a-z0-9]{0,253}[a-z0-9])?\\.[a-z]{2,63})|((\\d{1,3}\\.){3}\\d{1,3}))(:\\d{1,5})?((\\/|\\?)((%[0-9a-f]{2})|[-\\w\\+\\.\\?\\/@~#&=])*)?$";
          const urlPattern = new RegExp(regexQuery,"i")
          if(method === "GET" && urlPattern.test(url))
            return {url , status: 200}
          console.error(error.stack || error)
          return { url, status: 500, error };
        }
      }));

      const statusCodes = responses.map(response => response.status);
      const urls = responses.map(response => response.url);
      const allOk = statusCodes.every(code => code >= 200 && code < 300);
      const allError = statusCodes.every(code => code >= 400 && code < 600);
      const hasWarning = statusCodes.some(code => code >= 400 && code < 600);
      const messageError = responses
      .map((response, index) => response.error !== undefined ? `${index} - ${response.error}` : null)
      .filter(error => error !== null);

      if (allOk) {
        return {Estado:'Ok',urls, messageError}
      } else if (allError) {
        return {Estado:'Error',urls, messageError}
      } else if (hasWarning) {
        return {Estado:'Warning',urls, messageError}
      }
    }
    return {Estado:'Error',urls:[], messageError: 'No se pudo obtener estado'}
  } catch (error) {
    console.error(error.stack || error);
    throw error
  }
};

const extractRequestsFromJson = (codigoMonitoreo, todos) => {
    const requests = [];
    try {
      const requestObj = JSON.parse(`[${codigoMonitoreo}]`);
      requestObj.forEach(request => {
        const { method, url, headers, body } = request;
        if (method && url) {
          requests.push({
            method,
            url,
            headers,
            body
          });
        }
      });
    } catch (error) {
      let messageError = `Error en la sintaxis de codigo monitoreo: ${error}`
      if(todos === false)
        throw messageError
    }
    return requests;
}

const prepararCuerpo = (body) => {
  const esXMLValido = (str) => {
    try {
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(str, "application/xml");
      return !xmlDoc.querySelector("parsererror");
    } catch (e) {
      return false;
    }
  };

  if (typeof body === 'string') {
    try {
      JSON.parse(body);
      return body;
    } catch (e) {
      if (esXMLValido(body)) {
        return body;
      }
      console.error('La cadena no es un JSON ni un XML válido', e.stack || e);
      return null;
    }
  } else if (typeof body === 'object' && body !== null) {
    return JSON.stringify(body);
  } else {
    return null;
  }
}